import React, { createContext, useState, useEffect, useContext } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';

// 1. Crear el contexto
const AuthContext = createContext();

// 2. Crear el proveedor del contexto
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const checkUser = async () => {
    setIsLoading(true);
    try {
      const session = await fetchAuthSession();

      if (session.tokens) {
        const idToken = session.tokens.idToken.payload;

        // Verificar grupos de Cognito (para UI)
        const groups = idToken['cognito:groups'] || [];
        const isUserAdmin = groups.includes('Admins');

        // DEBUG: Logs para verificar (remover en producción)
        console.log('🔍 AuthContext - Cognito groups:', groups);
        console.log('🔍 AuthContext - User is admin (groups):', isUserAdmin);

        setUser(idToken);
        setIsAdmin(isUserAdmin);
      } else {
        setUser(null);
        setIsAdmin(false);
      }
    } catch (error) {
      console.log('No hay usuario autenticado', error);
      setUser(null);
      setIsAdmin(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Escuchar eventos de autenticación del Hub de Amplify
    const unsubscribe = Hub.listen('auth', ({ payload }) => {
      const { event } = payload;
      console.log('Auth event:', event);
      if (event === 'signedIn' || event === 'tokenRefresh') {
        checkUser();
      }
      if (event === 'signedOut') {
        setUser(null);
        setIsAdmin(false);
      }
    });
    
    // Comprobar el usuario al cargar la página por primera vez
    checkUser();
    
    // Limpiar la suscripción al desmontar el componente
    return () => {
      unsubscribe();
    };
  }, []);

  const value = { user, isAdmin, isLoading };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// 3. Crear un hook personalizado para usar el contexto fácilmente
export const useAuth = () => useContext(AuthContext);